export default __webpack_public_path__ + "static/media/awaiting6F.55ceb568.svg";